import { Injectable } from "@angular/core";
import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";
import { StandortModelView } from "../../types/StandortModel";

@Injectable({
    providedIn: 'root'
})
export class StandortViewService extends RestReadServiceBase<StandortModelView> {
    constructor(
    ) {
        super("StandortModelView", false);
    }        
}